// ABOUTME: Dedicated progression modal for the Amazon-initiated SP-API OAuth flow.
// ABOUTME: Two steps — Credentials and Sync — pre-seeded with refresh_token + selling_partner_id from props.

import { useTranslation } from 'react-i18next';

import ProgressionModal from '../../../theme/ProgressionBuilder/ProgressionModal';
import ProgressionWrapper from '../../../theme/ProgressionBuilder/ProgressionWrapper';
import Credentials from './views/Credentials';
import Sync from '../MpAddWebshop/views/Sync';
import { useCreateWebshopCredentialsMutation } from '../../../../newapi/webshop/webshopSlice';

const MpAmazonOAuthFinalize = (props) => {
    const { t } = useTranslation();

    const onSave = () => {
        if (props.handleClose) props.handleClose();
    };

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper
                onSave={onSave}
                query={useCreateWebshopCredentialsMutation}
                isModal
                title={t('finalize_amazon_connection')}
            >
                <Credentials
                    refreshToken={props.refreshToken}
                    sellingPartnerId={props.sellingPartnerId}
                />
                <Sync/>
            </ProgressionWrapper>
        </ProgressionModal>
    );
};

export default MpAmazonOAuthFinalize;
